export const MAPBOX_API_KEY =
  'pk.eyJ1IjoiZXhyIiwiYSI6ImNpajlhdHlwczAwMm50d2tuMmN5d3pkYjYifQ.nZJQoIQeQYa30OlvsRKN5A';
